import React from 'react';
import TextField from './index';
//Other
import { utils } from '../../../utils/utils';

const InputEmail = ({ label = 'Correo electrónico', name = 'email', value, onChange, ...rest }) => {
    const handleValueChange = (event) => {
        onChange(event.target.value.trim());
    }

    return (
        <TextField
            {...rest}
            fullWidth
            required
            label={label}
            name={name}
            value={value || ""}
            error={!!value && utils.validateMail(value)}
            onChange={handleValueChange}
            helperText={!!value && utils.validateMail(value) ? "Email invalido" : ''}
        />
    );
}

export default InputEmail;